module.exports = __webpack_public_path__ + "files/5ada068af381e4fcec8b9d488c429715.png";